import {useEffect} from 'react';
import {BrowserRouter} from 'react-router-dom';
import {useSettings} from '@/providers';
import {AppRouting} from './routing';
import {PathnameProvider} from './providers';
import Hotjar from '@hotjar/browser';
import * as Sentry from "@sentry/react";

const siteId = 6425634;
const hotjarVersion = 6;

const {BASE_URL} = import.meta.env;

const App = () => {
    const {settings} = useSettings();
    const env = import.meta.env.VITE_APP_ENV;

    if (env === "production" || env === "testing") {
        Sentry.init({
            dsn: "https://953dc9d76c5a416668064892ea345d98@o4509473200078848.ingest.de.sentry.io/4509473201848400",
            sendDefaultPii: true,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],
            tracesSampleRate: 1.0,
            tracePropagationTargets: [
                "localhost",
                /^https:\/\/buddy-testing\.upflinx\.com/,
                /^https:\/\/testing\.upflinx\.com/
            ],
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        });
    }

    useEffect(() => {
        if (env === 'production') {
            Hotjar.init(siteId, hotjarVersion);
        }
    }, []);

    useEffect(() => {
        document.documentElement.classList.remove('dark');
        document.documentElement.classList.remove('light');
        document.documentElement.classList.add(settings.themeMode);
    }, [settings]);

    return (
        <BrowserRouter basename={BASE_URL}>
            <PathnameProvider>
                <AppRouting/>
            </PathnameProvider>
        </BrowserRouter>
    );
};

export {App};
